module.exports = __webpack_public_path__ + "static/media/icon_caret_left.1f24144f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_caret_left.svg
// module id = 1055
// module chunks = 0